import { Action, action, State, ThunkOn, thunkOn } from 'easy-peasy';
import { StoreState } from './store';
import { PlayerError } from '../errors/PlayerError';

export interface ErrorState {
  error: PlayerError | null;
  setError: Action<ErrorState, PlayerError>;
  reset: Action<ErrorState>;
  onPlayerMount: ThunkOn<ErrorState, any, StoreState>;
  onPlayerDestroy: ThunkOn<ErrorState, any, StoreState>;
}

const initialState: State<ErrorState> = {
  error: null,
};

export const errorState: ErrorState = {
  /*================
   * State      
   ================*/
  ...initialState,

  /*================
   * Actions      
   ================*/

  setError: action((state, error) => {
    state.error = error;
  }),

  reset: action(state => {
    Object.assign(state, { ...initialState });
  }),

  onPlayerMount: thunkOn(
    function observer(_, storeActions) {
      return [storeActions.config.load.startType];
    },
    function handler(actions) {
      actions.reset();
    }
  ),

  onPlayerDestroy: thunkOn(
    function observer(_, storeActions) {
      return [storeActions.player.destroy.startType];
    },
    function handler(actions) {
      actions.reset();
    }
  ),
};
